import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import HeaderApp from "../../components/HeaderApp";
import TableEvidencias from "../../components/TableEvidencias";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";

const Evidencias = () => {
  const navigate = useNavigate();

  return (
    <>
      <HeaderApp />
      <Box
        component="main"
        sx={{
          flex: 1,
          py: 4,
          px: 2,
          bgcolor: "background.default",
          minHeight: "calc(100vh - 64px)",
        }}
      >
        <Container maxWidth="lg">
          <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2} mb={3}>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              Evidencias y resultados
            </Typography>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => navigate("/evidencias/nueva")}
            >
              Agregar evidencia
            </Button>
          </Box>
          <TableEvidencias />
        </Container>
      </Box>
    </>
  );
};

export default Evidencias;
